module.exports = __webpack_public_path__ + "img/ambpoker.db5f04bb.png";